import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { SECTION_MIN_HEIGHT } from "../../utils/constants";
import ProductTypeDialog from "./createScreen/ProductTypeDialog";
import AddProduct from "./createScreen/AddProduct";
import AddScreen from "./createScreen/AddScreen";
import EditScreens from "./product/components/EditScreens";
import ScreensList from "./product/ScreensList";

type Props = {};

const Screens = (props: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSelectTypeDialog, setActiveSelectTypeDialog] = useState(false);

  const handleCloseSelectTypeDialog = (type?: any) => {
    // changeLater
    if (type) {
      if (type === "PRODUCT") {
        navigate("/product/product/create");
      }
      if (type === "COMPONENT") {
        navigate("/product/component/create");
      }
      if (type === "PAGE") {
        navigate("/page/create");
      }
    }
    setActiveSelectTypeDialog(false);
  };

  useEffect(() => {
    if (window.location.pathname?.includes("/product/create")) {
      setActiveSelectTypeDialog(true);
    }
  }, [location.pathname]);
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: SECTION_MIN_HEIGHT,
      }}
    >
      {activeSelectTypeDialog && (
        <ProductTypeDialog
          activeDialog={activeSelectTypeDialog}
          handleDialog={handleCloseSelectTypeDialog}
          type="screen"
        />
      )}

      <Routes>
        <Route path="/" element={<ScreensList />} />
        <Route path="/multiple-edit" element={<EditScreens />} />
        <Route path="/create" element={<AddScreen />} />
        <Route path="/edit/:id" element={<AddScreen />} />
      </Routes>
    </Box>
  );
};

export default Screens;
